/* globals DEBUG_INFO_ENABLED */
import { fsBackendRoute } from './config.backendRoute';

/** @ngInject */
export function config($logProvider, $compileProvider, $translateProvider, $httpProvider, RestangularProvider,
    tmhDynamicLocaleProvider, $mdThemingProvider, $qProvider, applicationInformation,
    $httpParamSerializerProvider) {
    'ngInject';

    const debugEnabled = DEBUG_INFO_ENABLED;
    $compileProvider.debugInfoEnabled(debugEnabled);
    $logProvider.debugEnabled(debugEnabled);
    $qProvider.errorOnUnhandledRejections = debugEnabled;

    $translateProvider.useStaticFilesLoader({
        files: [{
            prefix: 'app/services/translations/',
            suffix: '.json'
        }, {
            prefix: 'app/services/translations/administration/',
            suffix: '.json'
        }]
    });

    $translateProvider.useSanitizeValueStrategy('escape');
    $translateProvider.fallbackLanguage(applicationInformation.defaultLanguage);
    $translateProvider.preferredLanguage(applicationInformation.defaultLanguage);

    // Enable i18n locale / formatting
    tmhDynamicLocaleProvider.localeLocationPattern('assets/angular/i18n/angular-locale_{{locale}}.js');

    // Setup session storage
    applicationInformation.serializer = $httpParamSerializerProvider.$get();
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.useApplyAsync(true);

    // Setup REST api
    if (fsBackendRoute !== null) {
        RestangularProvider.setBaseUrl(fsBackendRoute); // Bound to the interface
    }

    // Angular Material Color Config
    $mdThemingProvider.definePalette('indigo', {
        '50': '#e7f2ff',
        '100': '#b5d1f2',
        '200': '#4996f4',
        '300': '#0a59b9',
        '400': '#094b9c',
        '500': '#15319C',
        '600': '#052f62',
        '700': '#06264f',
        '800': '#052143',
        '900': '#041a3c',
        'A100': '#96c3f9',
        'A200': '#4d99f5',
        'A400': '#094b9c',
        'A700': '#042145',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 300 400 A100'
    });

    $mdThemingProvider.definePalette('red', {
        '50': '#FDE7E7',
        '100': '#F8B0B0',
        '200': '#F69191',
        '300': '#F58181',
        '400': '#F37171',
        '500': '#F26161',
        '600': '#D95757',
        '700': '#C24E4E',
        '800': '#A94444',
        '900': '#913A3A',
        'A100': '#F8A1A1',
        'A200': '#F56969',
        'A400': '#F35757',
        'A700': '#F24444',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 A100 A200'
    });

    $mdThemingProvider.definePalette('blue', {
        '50': '#DAE9F9',
        '100': '#82B6EA',
        '200': '#509AE2',
        '300': '#378BDD',
        '400': '#1E7DD9',
        '500': '#056ED5',
        '600': '#0463BF',
        '700': '#0458AA',
        '800': '#034D95',
        '900': '#034280',
        'A100': '#82BEF8',
        'A200': '#3897F5',
        'A400': '#1F8AF3',
        'A700': '#067DF2',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 300 400 A100'
    });

    $mdThemingProvider.definePalette('white', {
        '50': '#eef0f3',
        '100': '#ced4d9',
        '200': '#a1adbb',
        '300': '#77889d',
        '400': '#67798f',
        '500': '#ffffff',
        '600': '#4d5b6b',
        '700': '#404c59',
        '800': '#343d48',
        '900': '#272e36',
        'A100': '#e5eaf0',
        'A200': '#c1c9d2',
        'A400': '#67798f',
        'A700': '#404c59',
        'contrastDefaultColor': 'dark',
        'contrastDarkColors': '50 100 200 A100 A200'
    });

    $mdThemingProvider.theme('default')
      .primaryPalette('indigo')
      .accentPalette('blue')
      .warnPalette('red');

    $mdThemingProvider.theme('accent2')
      .primaryPalette('blue');

    $mdThemingProvider.theme('accent')
      .dark()
      .primaryPalette('white');

    $mdThemingProvider.theme('primary')
      .dark()
      .primaryPalette('white');
}
